import { Outlet } from 'react-router';
import { IntegrationType } from '../integrations/partner';
import AccessDenied from '../util/AccessDenied';
import { useIntegrationScope } from './permission';

/**
 * Component that protects integration routes - only allows access if user
 * has permissions for the specific integration
 */
export function RequireIntegrationAccess({ integration }: { integration: IntegrationType }) {
  const { isIntegrationReviewer, canAccess } = useIntegrationScope();

  // Non-integration reviewers have full access
  if (!isIntegrationReviewer) {
    return <Outlet />;
  }

  // Integration reviewers need specific access
  if (canAccess(integration)) {
    return <Outlet />;
  }

  // Access denied
  return <AccessDenied />;
}

/**
 * Component that blocks all integration reviewers - only allows access for non-integration reviewers
 */
export function RequireNonIntegrationReviewer() {
  const { isIntegrationReviewer } = useIntegrationScope();

  // Non-integration reviewers have full access
  if (!isIntegrationReviewer) {
    return <Outlet />;
  }

  // Access denied for all integration reviewers
  return <AccessDenied />;
}
